const bodyLockClass = 'is-popup-open';
const openClass = 'is-open';
const transitionDuration = 240;

function setBodyLock() {
  const hasOpenPopup = document.querySelector('.js-popup:not([hidden]), .js-language-popup:not([hidden])');
  document.body.classList.toggle(bodyLockClass, Boolean(hasOpenPopup));
}

export function initLanguagePopup() {
  const popup = document.querySelector('.js-language-popup');
  const trigger = document.querySelector('.js-language-open');

  if (!popup || !trigger) {
    return;
  }

  const dialog = popup.querySelector('.js-language-popup-dialog');
  const closeButtons = popup.querySelectorAll('.js-language-popup-close');
  let lastFocusedElement = null;
  let closeTimer = null;

  function openPopup() {
    window.clearTimeout(closeTimer);
    lastFocusedElement = trigger;
    popup.hidden = false;
    setBodyLock();
    window.requestAnimationFrame(() => {
      popup.classList.add(openClass);
      dialog.focus();
    });
  }

  function closePopup() {
    window.clearTimeout(closeTimer);
    popup.classList.remove(openClass);

    closeTimer = window.setTimeout(() => {
      popup.hidden = true;
      setBodyLock();

      if (lastFocusedElement) {
        lastFocusedElement.focus();
        lastFocusedElement = null;
      }
    }, transitionDuration);
  }

  trigger.addEventListener('click', openPopup);

  closeButtons.forEach((button) => {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden && popup.classList.contains(openClass)) {
      closePopup();
    }
  });
}
